<template>
    <div>
        <report-header
            :title="title"
            :isShowDateRange="true"
            :formatDateRangeTitle="dateRange"
        />
        <b-card id="report-card">
            <div id="report-body" class="w-100">
                <QTable
                    :data="result"
                    :columns="formattedColumns"
                    :hide-bottom="true"
                    :rows-per-page-options="[0]"
                    :loading="isLoading"
                    class="q-table"
                >
                    <template v-slot:body-cell-first_name="props">
                        <td>
                            <a
                                v-if="props.row.client_isactive"
                                :href="
                                    '/view/client/profile/' +
                                    props.row.encoded_id
                                "
                            >
                                {{ props.value }}
                            </a>
                            <span v-else>{{ props.value }}</span>
                        </td>
                    </template>
                    <template v-slot:body-cell-last_name="props">
                        <td>
                            <a
                                v-if="props.row.client_isactive"
                                :href="
                                    '/view/client/profile/' +
                                    props.row.encoded_id
                                "
                            >
                                {{ props.value }}
                            </a>
                            <span v-else>{{ props.value }}</span>
                        </td>
                    </template>
                    <template
                        v-slot:bottom-row
                        v-if="result.length == 0 && !isLoading && !isError"
                    >
                        <q-tr>
                            <q-td colspan="12">No records available</q-td>
                        </q-tr>
                    </template>
                    <template v-slot:header-cell="{ col }">
                        <th>
                            <strong>{{ col.label }}</strong>
                        </th>
                    </template>
                </QTable>
            </div>
        </b-card>
    </div>
</template>
<script>
import Report from "@/mixins/report.js";
import "@/css/quasar-table.css";
import { QTable } from "quasar";
import ReportService from "@/services/report";
import CREPORT from "@/constants/report";
export default {
    components: {
        QTable,
        ReportHeader: () => import("@/components/report/report-header")
    },
    mixins: [Report],
    props: {
        data: {
            type: Object,
            default() {
                return {
                    start: this.getStartDate("month"),
                    end: this.getStartDate("day")
                };
            }
        }
    },
    data() {
        return {
            isLoading: true,
            result: [],
            dateRange: "",
            title: "Total Billed and Collected by Client",
            isError: false
        };
    },
    mounted() {
        let self = this;
        // --- toggle navigation options
        self.data.isShowDateRange = true;
        self.data.datePickerOptionDefault = 1;

        self._getSetting().then(() => {
            self.data.start = self.getStartDate("month");
            self.data.end = self.getEndDate("day");
            self.data.from = self.converToUnix(self.data.start);
            self.data.to = self.converToUnix(self.data.end);
            self.init();
        });

        self.$root.$on("report-filter-date-range:refresh", self.init);
        self.$root.$on("total-billed-and-collected:refresh", function () {
            self.refresh = 1;
            self.init();
        });

        window.scrollTo(0, 0);
    },

    beforeDestroy: function () {
        this.data.filterDateOption = true;
        this.$root.$off("report-filter-date-range:refresh", this.init);
    },
    methods: {
        async init(params) {
            let self = this;

            self.isLoading = true;
            self.isError = false;

            if (params) {
                self.data.from = params.from;
                self.data.to = params.to;
                self.refresh = params.refresh;
            }
            self.dateRange = self.getDateRange(self.data.from, self.data.to);

            await ReportService.getReport(
                CREPORT.TYPE.TOTAL_BILLED_AND_COLLECTED,
                {
                    from: self.data.from,
                    to: self.data.to,
                    refresh: self.refresh
                }
            )
                .then(res => {
                    if (res && res.message && res.message.code === 200) {
                        self.result = res.resource.results;
                        self.title = res.resource.meta.title;
                        self.dynamicPageTitle(self.title);
                        self.dateRange = self.getDateRange(
                            res.resource.meta.fromDate,
                            res.resource.meta.toDate
                        );
                    } else {
                        throw new Error("Error: Unable to get the report.");
                    }
                })
                .catch(e => {
                    console.error(e);
                    self._message("Error: Unable to get the report.", "danger");
                    self.isError = true;
                })
                .finally(() => {
                    self.isLoading = false;
                });
        }
    },

    computed: {
        formattedColumns() {
            return [
                {
                    name: "first_name",
                    label: "First Name",
                    field: "First Name",
                    align: "left",
                    style: "white-space: nowrap"
                },
                {
                    name: "last_name",
                    label: "Last Name",
                    field: "Last Name",
                    align: "left",
                    style: "white-space: nowrap"
                },
                {
                    name: "Total Billed",
                    label: "Total Billed",
                    field: "Total Billed",
                    align: "left",
                    style: "white-space: nowrap"
                },
                {
                    name: "% of Total Billed",
                    label: "% of Total Billed",
                    field: "% of Total Billed",
                    align: "left",
                    style: "white-space: nowrap"
                },
                {
                    name: "Total Collected",
                    label: "Total Collected",
                    field: "Total Collected",
                    align: "left",
                    style: "white-space: nowrap"
                },
                {
                    name: "% of Total Collected",
                    label: "% of Total Collected",
                    field: "% of Total Collected",
                    style: "white-space: nowrap",
                    align: "left"
                },
                {
                    name: "Avg Transaction",
                    label: "Avg Transaction",
                    field: "Avg Transaction",
                    align: "left",
                    style: "white-space: nowrap"
                }
            ];
        }
    }
};
</script>
